import React, { useEffect, useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import { SelectAutocomplete } from '_components/FormElements/FormInput'
import { Card, CardBody, Container, Row, Col, Media, CardHeader, ListGroupItem, Modal,
  ListGroup, UncontrolledTooltip } from "reactstrap";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import UserFilter from "components/Filter-Right/UserFilter.js";
import pagination from "views/Hoc/pagination.js";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from 'axios';
import { Spinner } from '../../Hoc/Spinner'
import TablePagination from '@material-ui/core/TablePagination';
import { TablePaginationActions } from 'views/Hoc/PaginationActions';
import Drawer from 'views/Hoc/Dialog/Globaldrawer'
import { commonService } from '_services/common.service';
import { history } from '_helpers';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Padding } from '@mui/icons-material';

 var FileSaver = require('file-saver');

export default function EventResponse(props) {
  
  let eventId = props.location?.state?.eventId ? props.location?.state?.eventId : 0;
  const { control } = useForm({ mode: 'onBlur' });
  // const ExampleTabs = () => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  let [loading, setLoading] = useState(false)
  let [page, setPage] = useState(0);
  let [rowsPerPage, setRowsPerPage] = useState(10);
  let [mode, setMode] = useState(1)
  let [meetingFilterChId, setMeetingFilterChId] = useState(null)
  const[option, setOption] = useState([])
  const[option2, setOption2] = useState([])

  const[seachCompany, setSeachCompany] = useState(null)
  const[seachResPonseType, setSeachResPonseType] = useState({id:1, name:"Signed Deal",mode: 1, firstLetter:'Exsibitor & Partner'})
  const[responseTypeDescription, setResponseTypeDescription] = useState('Search 😎 Signed Deal In Both Exibitor And Partner')

  const [state, setState] = useState({totalResponse: 0, dataTableResponse: []});
  const [searchState, setSearch] = useState({ dropdownChannelList: null, searchEv: [] , searchch: [] ,  dropdownEventList: null });

  const [topList, setTopList] = useState(null);
  const[filterOption, setFilterOption] = useState(null)

   let adminUser = JSON.parse(localStorage.getItem('CHuser'));
   let updResponse =['', '😎 Signed Deal','😐 Work in Progress',"😔 No Deal / No Interest","🤔No Answer Yet","🤝Existing Partner",'',"😑 Meeting did not happen"]; 

  useEffect(() => {
    //getEventNameList();    
    getChannelsList();
    //getResponseTableData(null, null);
    getResponseTableData(seachCompany, seachResPonseType)
  }, []);

 const handleChangePage = (event, newPage) => {
    page = newPage;
    setPage(page);
    getResponseTableData(seachCompany, seachResPonseType);
  };



   const getInitialCnt = async() => {

     let data = {    
      eventId: eventId, 
    }
      await axios.post('/channelAdmin/getInitialResponseCnt', data).then(res => {
        
        if(res.data) {
           setTopList({totalMeetings: 3, totalBuyer: res.data.totalBuyer, totalExibitor: res.data.totalExibitor, wip: res.data.wip, nodeal: res.data.nodeal, noAns: res.data.master.noAns, untouched: res.data.untouched });
           console.log('res.data.totalMeetings : ', res.data.totalMeetings)
          
        }
      }).catch(err => {        
      });
    }

  const getChannelsList = () => {
      axios.get('/channelAdmin/channelAccountsName/' + adminUser.userId + '/live').then(res => {
  
        //console.log("page-->customer-->api-->channelAdmin/pendingChannelsList/", new Date())
        let data = [];
        data.push(...res.data)
        data = data.map(x => {
          return { name: x.name.trim(), id: x.id }
        });
        let contact = [];
        res.data.map(x => {  
          x.contacts.map(c => {
            contact.push({ name: c.firstName + ' ' + c.lastName, id: x.id, companyName: x.name.trim() });
          })
        });   
        data.push(...contact);
        console.log('data  >> : ', data);
        setOption2(data)
      }).catch(err => {
        
      });
      //getInitialCnt();
    }
 const getEventNameList = () => {
    axios.get('/channelAdmin/getAllEventsFilterOptions').then(res => {
      let data = [];
      res.data.map(x => {
        data.push({ name: x.name.trim(), id: x.id });
      })
     // searchState.dropdownEventList = data;
      setOption(data)
       setLoading(false);      
    })
  }
  const handleChangeRowsPerPage = (event) => {
    rowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(rowsPerPage);
    getResponseTableData(seachCompany, seachResPonseType);
  };
   const handleChangeRespFilter = (input, value) => {
    console.log('input ', input)
     console.log('value ', value)
      state.dataTableResponse = [];
      state.totalResponse = 0;
      loading = false;
      setLoading(loading);
      setState({ ...state });


      if(input == 'resptype' && value != null) {
        if(+value?.mode == 1) {
          setResponseTypeDescription('Search '+ value.name +' In Both Exibitor And Partner')
        } else if(+value?.mode == 2) {
          setResponseTypeDescription('Search '+ value.name +' In Only In Exibitor')
        } else if(+value?.mode == 3) {
          setResponseTypeDescription('Search '+ value.name +' In Only In Partner')
        }
        
        setSeachResPonseType(value)
      }
      if(value != null) {
        if(eventId != null) {
         // console.log('value 123 ', value)
          getResponseTableData(seachCompany , value);
        }
      } else {
        setSeachResPonseType({id:7, name:"All"  , firstLetter:'Exibitor & Partner', mode: 1})
          console.log('exibitor:', )
          getResponseTableData(seachCompany, {id:7, name:"All"  , firstLetter:'Exibitor & Partner', mode: 1});
      }
   }

   const handleChangeSelectFilter = (input, value) => {
    console.log('handleChangeSelectFilter channelId : ', value)
     state.dataTableResponse = [];
      state.totalResponse = 0;
      loading = false;
      setLoading(loading);
      setState({ ...state });
      setSeachCompany(value)
      if(value != null) {
        setMeetingFilterChId(value)
        if(eventId != null) {
          getResponseTableData(value , seachResPonseType);
        }
      } else {
          setSeachResPonseType({id:7, name:"All"  , firstLetter:'Exibitor & Partner', mode: 1})
          console.log('exibitor:', )
          getResponseTableData(null , seachResPonseType);
      }
    }
  const downloadReport = () => {
     setLoading(true);
         
      let flchannelId = (filterOption.channelId)?filterOption.channelId:0;
      let flmode = (filterOption?.mode)?filterOption?.mode:1;
      let flresponse = (filterOption?.response)?filterOption?.response:1;

        axios.get('/channel/getEventMeetingExibitorReport/'+eventId, { responseType: 'arraybuffer'}).then(res => {
              let  fileName = 'Exibitor_Meeting_Response.xlsx';                   
              var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              FileSaver.saveAs(blob, fileName);
              setLoading(false);
        });
  }
  const downloadBuyerReport = () => {
     setLoading(true);
      var fileDownload = require('js-file-download');
      axios.get('/channel/getEventMeetingBuyerReport/'+eventId, { responseType: 'arraybuffer'}).then(res => {
          let  fileName = 'Buyer_Meeting_Response.xlsx';                    
          var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              FileSaver.saveAs(blob, fileName);
              setLoading(false);
          });
  }

  const getResponseTableData = (ch, resp) => {
    console.log(' ch : ', ch)
    setLoading(true);
    let data = {
      page: page * rowsPerPage,
      limit: rowsPerPage,
      eventId: eventId, //(event?.id)? +event?.id:null,
      channelId: (ch)?ch?.id:null,
      mode:(resp)?resp?.mode:1,
      response: (resp)?resp?.id:1
    }
    setFilterOption(data)
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.post('/channelAdmin/getMeetingContatList', data
    ).then(res => {      
      loading = false;
      setLoading(loading);
      setState({totalResponse: res.data.count, dataTableResponse: res.data.rows });
      setTopList({totalMeetings: res.data.master.totalMeetings, totalBuyer: res.data.master.totalBuyer, totalExibitor: res.data.master.totalExibitor, wip: res.data.master.wip, nodeal: res.data.master.nodeal, noAns: res.data.master.noAns, untouched: res.data.master.untouched });
    }).catch((err) => {
      state.dataTableResponse = [];
      state.totalResponse = 0;
      loading = false;
      setLoading(loading);
      setState({ ...state });
    })
  }

  const MeetingList = {
     
     renderer: (row, rowIndex, index) => {
     console.log('rowuser', index);
      return (
        <div style={{ width: '100%' }}>
           
            {row?.meetings && row?.meetings.length > 0 ? row?.meetings.map((x, i) => {
             
            return(<ListGroup className="list my--2" flush key={'table' + x.channelJCTId}>
              <ListGroupItem className="px-0">
              <Row className="align-items-center">
                  <div className="col-3">
                      <p className="mb-0" style={{ fontSize: '0.7rem' , color:"#333;"}}>
                        Company Name 
                      </p>
                      <p style={{maxHeight:"150px"}}>
                       {x.record.companyName}
                       </p>
                  </div>
                  <div className="col-2">
                      <p className="mb-0" style={{ fontSize: '0.7rem' , color :"#815cd8"}}>
                        Contact Name
                      </p>
                       <p style={{maxHeight:"150px"}}>
                       {x.record.firstName}  {x.record.lastName}
                       </p>
                  </div>
                   <div className="col-3">
                      <p className="mb-0" style={{ fontSize: '0.7rem' , color:"#815cd8"}}>
                        Meeting
                      </p>
                       <p style={{maxHeight:"150px"}}>
                       {x.meetings[0].name} 
                       </p>
                  </div>

                   <div className="col-2">
                      <p className="mb-0" style={{ fontSize: '0.7rem' , color:"#815cd8" }}>
                        Response Type
                      </p>
                       <p style={{maxHeight:"150px"}}>
                       {(x.meetings[0].responseType == null)? 'Not Responded' : updResponse[x.meetings[0].responseType]} 
                       </p>
                  </div>
                  <div  className="col-2">
                      <p className="mb-0" style={{ fontSize: '0.7rem' , color:"#815cd8" }}>
                        Acknowedged
                      </p>
                       <p style={{maxHeight:"150px"}}>
                       {(x.meetings[0]?.responseReceived == null)? 'Not Yet' : 'Yes'} 
                       </p>
                  </div>
              </Row>
              </ListGroupItem>
            </ListGroup>)
            
            })
            :
            <><p style={{ marginLeft: "10%"}}>Meetings contact not found for this user</p></>
            }
        </div>
      )
    }
  }







  return (    
    <> 

        <div id="channelList">
          <Card style={{ padding: '20px' }}>
            <Row>
                <Col lg='6'>
                <Card style={{marginLeft:"10%", padding:"3px", display: topList?.totalMeetings > 0 ? 'inline-block':'none' }}>
                  <p>Total number of meetings. : {topList?.totalMeetings} </p>
                  <p>Total number of buyer companies : {topList?.totalBuyer} </p>
                  <p>Total number of exhibitors companies : {topList?.totalExibitor} </p>             
                </Card>
                </Col>

                <Col  lg='6'>
                <Card style={{display: topList?.totalMeetings > 0 ? 'inline-block':'none' }}>
                  <p>% of no activity (people who have not connected at all) : {topList?.untouched}</p>
                  <p>% of Not yet anwers : {topList?.noAns} </p>
                  <p>% WIP : {topList?.wip} </p>
                  <p>% No Deal : {topList?.nodeal} </p>
                </Card>
                </Col>
            </Row>
          </Card>  
           <Row>
                  {responseTypeDescription && <Col  lg='12'>
                  <p style={{color: '#ec8b78' , textAlign:"center"}}>{responseTypeDescription} </p>
                  </Col>  }
                </Row>
          <Container className="mt--3" fluid>
              <Row> 
                <div className="col">         
                <Card style={{ padding: '20px' }}>
                  <CardHeader>
                    <h3 className="mb-0">Event Meeting Follow UP </h3>
                    {/* <p className="text-sm mb-0">
                        This is an exmaple of data table using the well known
                        react-bootstrap-table2 plugin. This is a minimal setup in
                        order to get started fast.
                      </p> */}
                  </CardHeader>            
              
              
               
                      {loading ? <Spinner /> : <ToolkitProvider
                        data={state.dataTableResponse}
                        ClassName="align-items-center table-flush" responsive
                        keyField="channelId"
                        columns={[
                          {
                            dataField: "channelJCTId",
                            text: "Channel JCT Id",
                            sort: true
                          },
                          {
                            dataField: 'exibitorName',
                            text: " Exibitor Detail",
                            sort: true,
                            formatter: (rowContent, row, rowIndex, index) => {
                              return (
                                <>
                                <span style={{ wordWrap:"break-word", width:"200px"}}>{row.contactList[0].reqCompamyName}</span>
                                  <p>{row.contactList[0].reqName} </p>                           
                                </>
                              )
                            }
                          },
                            {
                            dataField: "meetings",
                            text: "Exibitor Response",
                            sort: true,
                            formatter: (rowContent, row, rowIndex, index) => {
                            

                              return (
                                <> {row.meetings.length ==0 ? 
                                  <p id= {'idr_' + row.channelJCTId} >Un Touched
                                  </p>                            
                                  :
                                  (row.meetings[0].updatedBy == row.contactList[0].reqContactId)?
                                  <>
                                  <p id= {'idr_' + row.channelJCTId} > {updResponse[row.meetings[0].responseType]} <p>{(row.meetings[0].responseReceived)?(row.meetings[0].responseReceived == '1' ? ' Confirmed ' : ' Declined ') : ''}</p> </p>
                                  
                                  
                                  <UncontrolledTooltip target={'idr_' + row.channelJCTId} placement='bottom'> {row.contactList[0].reqName +' Input: '+ updResponse[row.meetings[0].responseType]}  </UncontrolledTooltip>
                                  </>
                                  :
                                  (row.meetings[0].updatedBy != row.contactList[0].reqContactId && +row.meetings[0].responseType == 1 && row.meetings[0].responseReceived != null)?
                                    <>
                                    <p id= {'idr_' + row.channelJCTId} > {updResponse[row.meetings[0].responseType]} <p>{(row.meetings[0].responseReceived == '1' ? ' Confirmed ' : ' Declined ')}</p> </p>
                                    
                                    <UncontrolledTooltip target={'idr_' + row.channelJCTId} placement='bottom'> { updResponse[row.meetings[0].responseType] + (row.meetings[0].responseReceived == '1' ? ' Confirmed ' : ' Declined ') +' by '+row.contactList[0].reqName } </UncontrolledTooltip>
                                    </>
                                  :
                                  <>
                                    <p>Untouched</p>
                                  </>                        
                                }  
                              </>
                              )


                            }
                          },
                          {
                            dataField: 'buyerContactName',
                            text: "Buyer Detail",
                            sort: true,
                            formatter: (rowContent, row, rowIndex, index) => {
                              return (
                                <><span style={{ wordWrap:"break-word", width:"200px"}}>{row.contactList[0].partnerCompanyName}</span>
                                  <p>{row.contactList[0].partnerName}</p>
                                  
                                </>
                              )
                            }
                          },
                          {
                            dataField: "meetings",
                            text: "Buyer Status",
                            sort: true,
                            formatter: (rowContent, row, rowIndex, index) => {
                          return (
                              <> {row.meetings.length ==0 || +row.meetings[0].responseType == 6 ? 
                                  <p id= {'idp_' + row.channelJCTId} >Un Touched
                                  </p>                            
                                  :
                                  (row.meetings[0].updatedBy == row.contactList[0].partnerContactId)?
                                  <>
                                  <p id= {'idp_' + row.channelJCTId} > {updResponse[row.meetings[0].responseType]} <p>{(row.meetings[0].responseReceived)?(row.meetings[0].responseReceived == '1' ? ' Confirmed ' : ' Declined '):''}</p> </p>
                                  <UncontrolledTooltip target={'idp_' + row.channelJCTId} placement='bottom'> {row.contactList[0].partnerName +' Input: '+ updResponse[row.meetings[0].responseType]}  </UncontrolledTooltip>
                                  </>
                                  :
                                  (row.meetings[0].updatedBy != row.contactList[0].partnerContactId && +row.meetings[0].responseType == 1 && row.meetings[0].responseReceived != null)?
                                    <>
                                    <p id= {'idp_' + row.channelJCTId} > {updResponse[row.meetings[0].responseType]} <p>{(row.meetings[0].responseReceived) ? (row.meetings[0].responseReceived == '1' ? ' Confirmed ' : ' Declined ') : ''}</p> </p>
                                    <UncontrolledTooltip target={'idp_' + row.channelJCTId} placement='bottom'> { updResponse[row.meetings[0].responseType] + (row.meetings[0].responseReceived == '1' ? ' Confirmed ' : ' Declined ') +' by '+row.contactList[0].partnerName } </UncontrolledTooltip>
                                    </>
                                  :
                                  <>
                                    <p>Untouched</p>
                                  </>                        
                                }  
                              </>
                              )
                            }
                          },
                          
                        ]}
                        search
                      >
                        {props => (
                          <div className="py-2 table-responsive">
                            <div
                              id="datatable-basic_filter"
                              className="dataTables_filter px-4 mb-2"
                            >
                              <div className='row'>
                                <div className='col-sm-6'>
                                  <SelectAutocomplete
                                    id="searchChannel"
                                    type="text"
                                    label="searchChannel"
                                    name="searchChannel"
                                    options={option2}
                                    placeholder="search..."
                                    disableCloseOnSelect
                                    className="d-inline-block"
                                    style={{ width: '48%', marginLeft: '20px' }}
                                    control={control}
                                    input='search'
                                    value={seachCompany}
                                    handleChangeSelect={handleChangeSelectFilter}
                                  // onInputChange={handleOnInputChange}
                                  />      

                                  <SelectAutocomplete
                                    id="searchResptype"
                                    type="text"
                                    label={responseTypeDescription}
                                    name="searchResptype"
                                    //options={option3}
                                    placeholder="response..."
                                    disableCloseOnSelect
                                    className="d-inline-block"
                                    style={{ width: '48%', marginLeft: '20px' }}
                                    control={control}
                                    input='resptype'
                                    value={seachResPonseType}
                                    handleChangeSelect={handleChangeRespFilter}
                                  // onInputChange={handleOnInputChange}
                                    options={option3.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                                    groupBy={(option) => option.firstLetter}
                                  />   

                                  {/* <SelectAutocomplete
                                    id="responded"
                                    type="text"
                                    label="responded"
                                    name="responded"
                                    options={option4}
                                    placeholder="response..."
                                    disableCloseOnSelect
                                    className="d-inline-block"
                                    style={{ width: '48%', marginLeft: '20px' }}
                                    control={control}
                                    input='resptype'
                                    value={respondedType}
                                    handleChangeSelect={handleChangeRespFilter}
                                  // onInputChange={handleOnInputChange}
                                  />  */}

                                </div>  

                                <div className='col-sm-6'>
                                    <button className="btn btn-primary float-right" type="button" onClick={downloadBuyerReport}>Buyer's Report</button>
                              
                                    <button className="btn btn-primary" type="button" style={{marginLeft:'50%'}} onClick={downloadReport}>Exibitor's Report</button>
                                </div>                   
                              </div>
                            </div>
                            <BootstrapTable
                              {...props.baseProps}
                              bootstrap4={true}
                              // pagination={pagination}
                            //  expandRow={MeetingList}
                              bordered={false}
                              hover={true}
                              rowClasses='pointer'
                            />

                            <TablePagination
                              component="div"
                              count={state.totalResponse}
                              page={page}
                              onChangePage={handleChangePage}
                              rowsPerPage={rowsPerPage}
                              onChangeRowsPerPage={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </div>
                        )}
                      </ToolkitProvider>}
            </Card>
           </div>
          </Row>
        </Container>
            
      </div> 
    </>

  );
}

const option3 = [
  {id:1, name:"Signed Deal"  , firstLetter:'Exibitor & Partner', mode: 1},
  {id:11, name:"Signed Deal-Confirmed"  , firstLetter:'Exibitor & Partner', mode: 1},
  {id:10, name:"Signed Deal-Declined"  , firstLetter:'Exibitor & Partner', mode: 1},
  {id:2, name:'Work in Progress'  , firstLetter:'Exibitor & Partner', mode: 1},
  {id:3,name: "No Deal / No Interest"  , firstLetter:'Exibitor & Partner', mode: 1},
  {id:4, name:"No Answer Yet"  , firstLetter:'Exibitor & Partner', mode: 1},
  {id:5, name:"Existing Partner" , firstLetter:'Exibitor & Partner', mode: 1},
  {id:6, name:"UnTouched"  , firstLetter:'Exibitor & Partner', mode: 1},
  {id:7, name:"All"  , firstLetter:'Exibitor & Partner', mode: 1},
  {id:8, name:"Meeting did not happen"  , firstLetter:'Exibitor & Partner', mode: 1},

  {id:1, name:'Signed Deal'  , firstLetter:'Only In Exibitor', mode: 2},
  {id:11, name:"Signed Deal-Confirmed"  , firstLetter:'Only In Exibitor', mode: 2},
  {id:10, name:"Signed Deal-Declined"  , firstLetter:'Only In Exibitor', mode: 2},
  {id:2, name: 'Work in Progress'  , firstLetter:'Only In Exibitor', mode: 2},
  {id:3,name: "No Deal / No Interest"  , firstLetter:'Only In Exibitor', mode: 2},
  {id:4, name:"No Answer Yet"  , firstLetter:'Only In Exibitor', mode: 2},
  {id:5, name:"Existing Partner" , firstLetter:'Only In Exibitor', mode: 2},
  {id:6, name:"UnTouched" , firstLetter:'Only In Exibitor', mode: 2},
  {id:8, name:"Meeting did not happen"  , firstLetter:'Only In Exibitor', mode: 2},

  {id:1, name:'Signed Deal' , firstLetter:'Only In Partner', mode: 3},
  {id:11, name:"Signed Deal-Confirmed"  , firstLetter:'Only In Partner', mode: 3},
  {id:10, name:"Signed Deal-Declined"  , firstLetter:'Only In Partner', mode: 3},
  {id:2, name: 'Work in Progress', firstLetter:'Only In Partner', mode: 3},
  {id:3,name: "No Deal / No Interest", firstLetter:'Only In Partner', mode: 3},
  {id:4, name:"No Answer Yet" , firstLetter:'Only In Partner', mode: 3},
  {id:5, name:"Existing Partner" , firstLetter:'Only In Partner', mode: 3},
  {id:6, name:"UnTouched" , firstLetter:'Only In Partner', mode: 3},
  {id:8, name:"Meeting did not happen"  , firstLetter:'Only In Partner', mode: 3},

]

  //  const option3 = option.map((option) => {
  //     const firstLetter = option.id;
  //     return {
  //        firstLetter: ([1,2,3,4,5,6].includes(firstLetter)) ? 
  //           'Exsibitor & Partner' : [7,8,9,10,11,12].includes(firstLetter) ? 'Only In Exsibitor' :'Only In Partner',
  //        ...option,
  //     };
  //  });

const option4 = [
  {id:6, name:'Partially Responded'},
  {id:7, name: 'UnTouched'},
  {id:7, name: 'Fully Responded'},
]

